import { Observable } from "rxjs";
import { Setting } from "../setting";

export abstract class SettingData {
  abstract listAll(): Observable<any[]>;

  abstract update(setting: Setting);
}
